import React, { useState } from 'react';

const suggestedQuestions = [
  'Em qual categoria o documento deveria estar?',
  'Você lembra quando o documento foi criado?',
  'Quem é o autor do documento?',
  'Você lembra de palavras-chave específicas do documento?'
];

interface NoResultsChatProps {
  query: string;
}

export const NoResultsChat: React.FC<NoResultsChatProps> = ({ query }) => {
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([
    {
      from: 'bot',
      text: `Olá! Não encontrei documentos que correspondam à sua pesquisa por "${query}".\nEsse documento que você está buscando está classificado em qual categoria?`
    }
  ]);

  const handleSend = () => {
    if (input.trim()) {
      setMessages([...messages, { from: 'user', text: input }]);
      setInput('');
      // Aqui pode ser feita a integração com o backend/chatbot
    }
  };

  const handleSuggestionClick = (suggestion: string) => {
    setInput(suggestion);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 w-4/5 mx-auto">
      <div className="mb-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">Nenhum resultado encontrado para "{query}"</h2>
        <p className="text-gray-500 mb-2">Talvez eu possa ajudar a encontrar o que você está procurando.</p>
      </div>
      <div className="flex items-start mb-4">
        <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Bot" className="w-10 h-10 rounded-full mr-3" />
        <div className="min-w-[400px] bg-gray-100 rounded-lg px-4 py-3 text-gray-800 flex-1">
          {messages[0].text}
        </div>
      </div>
      <div className="mb-2">
        <span className="text-gray-700 font-medium">Perguntas sugeridas:</span>
        <div className="flex flex-wrap gap-2 mt-2">
          {suggestedQuestions.map((q, idx) => (
            <button
              key={idx}
              className="bg-gray-200 hover:bg-blue-100 text-gray-800 rounded-full px-3 py-1 text-sm"
              onClick={() => handleSuggestionClick(q)}
              type="button"
            >
              {q}
            </button>
          ))}
        </div>
      </div>
      <div className="flex items-center mt-4">
        <input
          type="text"
          className="flex-1 border border-gray-300 rounded-l-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Digite sua resposta..."
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') handleSend(); }}
        />
        <button
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-r-md"
          onClick={handleSend}
          type="button"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </button>
      </div>
    </div>
  );
}; 